export enum HelpMeCategories {
  login = 'login',
  patient = 'patient',
  message = 'message',
  diary = 'diary',
  scheduled_task = 'scheduled_task',
  document = 'document',
  template = 'template',
  tracker = 'tracker',
  group = 'group',
  nutrition = 'nutrition',
  bill = 'bill',
}

export class HelpMeCategoriesTools {
  static getLabelCategory(category: HelpMeCategories, withPrefix = true) {
    switch (category) {
      case HelpMeCategories.login:
        return (withPrefix ? 'Sujet : ' : '') + 'Connexion/Inscription';
      case HelpMeCategories.patient:
        return (withPrefix ? 'Sujet : ' : '') + 'Patients';
      case HelpMeCategories.message:
        return (withPrefix ? 'Sujet : ' : '') + 'Messages';
      case HelpMeCategories.diary:
        return (withPrefix ? 'Sujet : ' : '') + 'Journaux';
      case HelpMeCategories.scheduled_task:
        return (withPrefix ? 'Sujet : ' : '') + 'Tâches programmées';
      case HelpMeCategories.document:
        return (withPrefix ? 'Sujet : ' : '') + 'Documents/Documents partagés';
      case HelpMeCategories.template:
        return (withPrefix ? 'Sujet : ' : '') + 'Templates';
      case HelpMeCategories.tracker:
        return (withPrefix ? 'Sujet : ' : '') + 'Trackers';
      case HelpMeCategories.group:
        return (withPrefix ? 'Sujet : ' : '') + 'Groupes';
      case HelpMeCategories.nutrition:
        return (withPrefix ? 'Sujet : ' : '') + 'Nutrition';
      case HelpMeCategories.bill:
        return (withPrefix ? 'Sujet : ' : '') + 'Facturation';
      default:
        return 'Sujet : Divers';
    }
  }

  static getAllValues(): any[] {
    return Object.keys(HelpMeCategories);
  }

  static displayUnauthenticatedCategory(category: HelpMeCategories) {
    return category === HelpMeCategories.login;
  }
}
